import type { DwtPayloadsMappedRow } from '../models/dwt-payloads-sheet.model';
import {
    DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL,
    isDwtPayloadReportStatusCode,
} from '../dwt-payloads.constants';
import { flattenJsonToColumns } from './flatten-json-to-columns.util';
import {
    formatDwtPayloadErrorsOrWarnings,
    parseDwtPayloadResponsePayload,
} from './parse-dwt-payload-validation.util';

function asRecord(value: unknown): Record<string, unknown> | null {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        return null;
    }
    return value as Record<string, unknown>;
}

function readString(value: unknown): string {
    if (typeof value === 'string') {
        return value;
    }
    if (value == null) {
        return '';
    }
    return String(value);
}

function readStatusLabel(value: unknown): string {
    const code = Number(value);
    if (Number.isInteger(code) && isDwtPayloadReportStatusCode(code)) {
        return DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL[code];
    }
    return readString(value);
}

export function mapDwtPayloadApiRecordToRow(record: unknown): DwtPayloadsMappedRow {
    const row = asRecord(record);
    const validation = parseDwtPayloadResponsePayload(row?.['responsePayload']);

    return {
        wasteTrackingId: readString(row?.['wasteTrackingId']),
        yourReference: readString(row?.['yourReference']),
        receivedAt: readString(row?.['processedAt']),
        status: readStatusLabel(row?.['status']),
        errorsOrWarnings: formatDwtPayloadErrorsOrWarnings(validation),
        payloadColumns: flattenJsonToColumns(row?.['requestPayload']),
    };
}
